import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Select } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../swzutils";
const VehicleCategorySelector = ({ value, marketplaceOnly = true, onChange }) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    useEffect(() => {
        loadVehicleCategories();
    }, []);
    const loadVehicleCategories = () => {
        setLoading(true);
        axios.get(`/admin/v1/tenants/registrations/vehicle-categories?marketplaceOnly=${marketplaceOnly}`).then(response => {
            const options = response.data
                .sort((a, b) => {
                if (a.description > b.description)
                    return 1;
                if (a.description < b.description)
                    return -1;
                return 0;
            })
                .map((category) => {
                return {
                    label: category.description,
                    value: category.name
                };
            });
            setLoading(false);
            setOptions(options);
        }).catch(axiosErrorHandler);
    };
    return (_jsx(Select, { loading: loading, mode: 'multiple', disabled: false, allowClear: false, placeholder: "Select vehicle categories", onChange: onChange, value: value, showSearch: {
            optionFilterProp: ['label']
        }, options: options }));
};
export default VehicleCategorySelector;
